var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hv-imageAD"},_vm._l((_vm.data.list),function(item,index){return _c('BaseImage',{key:index,attrs:{"data":item,"fit":_vm.data.fit}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }